import React from "react";
import {
  FaTimes,
  FaShieldAlt,
  FaUserCheck,
  FaPen,
  FaFileContract,
  FaUser,
  FaUserAlt,
  FaRegCheckCircle,
  FaExclamationTriangle,
  FaEnvelope,
  FaLock,
  FaMoneyBillWave,
  FaBan,
  FaBalanceScale,
  FaPhoneAlt,
} from "react-icons/fa";
import { BsCheckLg } from "react-icons/bs";
import { motion } from "framer-motion";
import { adminEmailAddress } from "../../utils/constants";

export default function PrivacyPage({ setViewMode }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="bg-white p-4 rounded-lg relative w-full min-h-screen overflow-y-auto"
    >
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-between items-center mb-6 border-b pb-4 border-gray-200">
          <div className="flex items-center">
            <FaShieldAlt className="text-[#363062] mr-2" size={20} />
            <h1 className="text-lg font-bold text-[#363062]">
              Privacy Policy and Information
            </h1>
          </div>
          <button
            className="flex items-center justify-center bg-[#363062] hover:bg-opacity-90 text-white p-2 rounded-full transition-all"
            onClick={() => setViewMode(false)}
          >
            <FaTimes size={16} />
          </button>
        </div>

        <div className="bg-gray-50 rounded-lg p-4 mb-6 border-l-4 border-[#8FCD00]">
          <p className="text-sm text-gray-600 flex items-center">
            <FaExclamationTriangle className="text-[#8FCD00] mr-2" />
            <span>
              Effective Date:{" "}
              <span className="font-medium">October 7, 2024</span>
            </span>
          </p>
        </div>

        <div className="space-y-6">
          {/* Section 1 */}
          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaFileContract className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                1. Acceptance of Terms
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              By accessing and using ELEGHO APP (the "Service"), you agree to
              comply with and be bound by these Terms and Conditions (the
              "Terms"). If you do not agree with these Terms, you must not use
              the Service.
            </p>
          </div>

          {/* Section 2 */}
          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaPen className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">2. Definitions</h2>
            </div>
            <ul className="text-sm text-gray-600 pl-7 space-y-2">
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  "User" refers to any individual or entity that accesses or
                  uses the Service.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  "Content" refers to any data, information, or material that a
                  User provides, uploads, or sends through the Service.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  "Company" refers to ELEGHO APP, the entity providing the
                  Service.
                </span>
              </li>
            </ul>
          </div>

          {/* Section 3 */}
          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaUserCheck className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">3. Eligibility</h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              You must be at least 18 years of age to use this Service. By using
              the Service, you represent that you have the authority to enter
              into these Terms.
            </p>
          </div>

          {/* Section 4 */}
          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaUser className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                4. Account Registration
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7 mb-2">
              To use certain features of the Service, you may need to create an
              account. You agree to:
            </p>
            <ul className="text-sm text-gray-600 pl-7 space-y-2">
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Provide accurate, current, and complete information during the
                  registration process.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Maintain the security of your password and account
                  information.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Notify the Company immediately of any unauthorized use of your
                  account.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Be responsible for all activities that occur under your
                  account.
                </span>
              </li>
            </ul>
          </div>

          {/* Section 5 */}
          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaRegCheckCircle className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                5. Use of the Service
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7 mb-2">
              You agree to use the Service for lawful purposes only and in
              accordance with applicable laws and regulations. You must not:
            </p>
            <ul className="text-sm text-gray-600 pl-7 space-y-2">
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Send unsolicited commercial emails (spam) or engage in any
                  form of illegal email marketing.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Use the Service to harass, abuse, or harm another person.
                </span>
              </li>
              <li className="flex items-start">
                <BsCheckLg className="text-[#8FCD00] mt-1 mr-2 flex-shrink-0" />
                <span>
                  Impersonate any person or entity or misrepresent your
                  affiliation with any person or entity.
                </span>
              </li>
            </ul>
          </div>

          {/* Remaining sections with appropriate icons */}
          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaUserAlt className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                6. Content Responsibility
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              You are solely responsible for the Content you submit through the
              Service. The Company does not guarantee the accuracy, integrity,
              or quality of any Content. By providing Content, you grant the
              Company a worldwide, non-exclusive, royalty-free license to use,
              reproduce, modify, and distribute such Content in connection with
              the Service.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaEnvelope className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                7. Compliance with Anti-Spam Laws
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              You agree to comply with all applicable laws regarding unsolicited
              commercial emails, including but not limited to the CAN-SPAM Act,
              GDPR, and other relevant regulations.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaMoneyBillWave className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                8. Fees and Payment
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              The use of the Service may require payment of fees. You agree to
              pay all applicable fees for the Service as outlined in the pricing
              plan you select. All fees are non-refundable unless stated
              otherwise.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaBan className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">9. Termination</h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              The Company reserves the right to suspend or terminate your access
              to the Service at any time, with or without cause, or with or
              without notice.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaExclamationTriangle
                className="text-[#363062] mr-2"
                size={16}
              />
              <h2 className="font-medium text-[#363062]">
                10. Limitation of Liability
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              To the extent permitted by law, the Company shall not be liable
              for any indirect, incidental, special, consequential or punitive
              damages, including but not limited to loss of profits, data or
              goodwill, arising from or related to your use of the Service.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaBalanceScale className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                11. Indemnification
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              You agree to indemnify, defend, and hold harmless the Company and
              its affiliates from any claims, losses, liabilities, damages,
              costs, or expenses arising from your use of the Service or your
              violation of these Terms.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaPen className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                12. Changes to Terms
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              The Company reserves the right to modify these Terms at any time.
              Your continued use of the Service after the modifications
              constitutes your acceptance of the new Terms.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaBalanceScale className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">13. Governing Law</h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              These Terms shall be governed by and construed in accordance with
              the laws of the Republic of the Philippines, without regard to its
              conflict of law principles.
            </p>
          </div>

          <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100 hover:border-[#8FCD00] transition-all">
            <div className="flex items-center mb-2">
              <FaPhoneAlt className="text-[#363062] mr-2" size={16} />
              <h2 className="font-medium text-[#363062]">
                14. Contact Information
              </h2>
            </div>
            <p className="text-sm text-gray-600 pl-7">
              For any questions regarding these Terms, please contact us at{" "}
              <a
                href={`mailto:${adminEmailAddress}`}
                className="text-[#363062] hover:text-[#8FCD00] transition-colors"
              >
                {adminEmailAddress}
              </a>
            </p>
          </div>
        </div>

        <div className="mt-8 mb-4 flex justify-center">
          <button
            onClick={() => setViewMode(false)}
            className="bg-[#363062] text-white px-6 py-2 rounded-md hover:bg-opacity-90 transition-all flex items-center"
          >
            <FaTimes className="mr-2" size={14} />
            Close Privacy Policy
          </button>
        </div>
      </div>
    </motion.div>
  );
}
